import * as React from "react";
import {loadWorkingConfig, updateConfigFromObject, workingConfig} from "../ConfigSignal";
import {findDisplayName} from "../configEdit/newNavTree/NavTree";
import {Dropdown, Loader} from "semantic-ui-react";
import {backend} from "../../../../../xconvert-backend";
import {authentication} from "../../../../../authentication";
import {useEffect} from "react";
import {ConfigContext} from "../../../context/ConfigContext";

export interface ScriptDropdownProps {
    scriptPath: string | undefined
    setScriptPath: (scriptPath: string | undefined) => void
    setScript: (script: string) => void
    readOnly: boolean
}

export function ScriptDropdown(props: React.PropsWithChildren<ScriptDropdownProps>) {

    const context = React.useContext(ConfigContext)

    const [scriptPaths, setScriptPaths] = React.useState<string[]>([])
    const [options, setOptions] = React.useState<any[]>([])

    useEffect(() => {
        if (workingConfig.value == undefined) {
            loadWorkingConfig(context.companyId).then(r => {})
        }
        loadOpenInModalPaths().then(paths => {
            filterPathsForPresents(paths).then(presentPaths => {
                console.log("SCRIPT_DROPDOWN filterPathsForPresents: ", presentPaths)
                setOptions(presentPaths)
            })
        })

        let path = props.scriptPath
        if(path == "" || path == undefined) {
            path = context.scriptConverterPlaygroundScriptPath
        }
        loadScriptFromContext(path)
    }, [])

    async function loadOpenInModalPaths() {
        let auth = backend.withTokenAuthHeader(authentication.token)
        let openInModalPaths = (await backend.internalApi.fetchCmNavTreeTextModalList(auth)).pathList
        setScriptPaths(openInModalPaths)
        return openInModalPaths
    }

    async function filterPathsForPresents(paths: string[]) {

        try {
            let presentPaths: string[] = []

            const jp = require('jsonpath');
            if (workingConfig.value == undefined) {
                await loadWorkingConfig(context.companyId)
            }
            let config = JSON.parse(workingConfig.value)

            paths.forEach((path) => {
                let script = jp.value(config, path)
                if (script) {
                    presentPaths.push(path)
                }
            })
            return presentPaths
        } catch (e) {
            console.error("SCRIPT_DROPDOWN Error in filterPathsForPresents: ", e)
            return []
        }
    }

    function loadScriptFromContext(path: string) {
        if (path == undefined) {
            return
        }
        // change in currentJSON
        const jp = require('jsonpath');
        const jsonPath = path.replace(".CompanyConfiguration", "");
        console.log("JSONPATH : ", jsonPath)

        try {
            let config = JSON.parse(workingConfig.value)
            var s = jp.value(config, jsonPath)
            // console.log("ScriptDropdown loadScriptFromContext, script: ", s)

            props.setScript(s)
        } catch (e) {
            console.log("Error in loadScriptFromContext: ", e)
        }
    }

    return <Dropdown
        style={{width: "100%", zIndex: 11}}
        search
        selectOnBlur={false}
        clearable
        options={options.map((value) => {

            let displayName = ""
            if(value && /\d/.test(value)) {
                let scriptParts = value.split(".")
                let scriptPartsToTake = []
                let beforeArrayIndex = true
                scriptParts.forEach((part) => {
                    if(beforeArrayIndex) {
                        scriptPartsToTake.push(part)
                    }
                    if(!isNaN(parseFloat(part))) {
                        beforeArrayIndex = false
                    }
                })
                let shortenedPath = scriptPartsToTake.join(".")
                let jp = require('jsonpath')

                let object = {}
                try {
                    let config = JSON.parse(workingConfig.value)
                    object = jp.value(config, shortenedPath)
                } catch (e) {
                    console.error("SCRIPT_CONVERTER_PLAYGROUND - DROPDOWN Error in loadScriptFromContext: ", e)
                }

                try {
                    displayName = objectToDropDownOptionsWithDisplayNames(object) + " - "
                } catch (e) {
                    console.error("SCRIPT_CONVERTER_PLAYGROUND - DROPDOWN Error in findDisplayName: ", e)
                }

            }
            return {
                key: value,
                value: value,
                text: displayName + value,
                description: displayName,
            }
        })}
        selection
        value={props.scriptPath}
        onChange={(evt, data) => {
            loadScriptFromContext(data.value.toString())
            context.setScriptConverterPlaygroundScriptPath(data.value.toString())
            props.setScriptPath(data.value.toString())
        }
        }
        disabled={props.readOnly}
    />
}

export function objectToDropDownOptionsWithDisplayNames(object: any) {
    let pairs = []
    Object.keys(object).forEach((key) => {
        pairs.push({
            name: key,
            value: object[key]
        })
    })
    return findDisplayName(pairs)
}